export default class formConfig {
  // 区管单位
  static configList() {
    return [
      {
        title: "区管单位详情",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "区管名称：",
            type: "input",
            value: "name",
            placeholder: "请输入",
            maxlength: 100,
            rule: {
              required: true,
              message: "请填写区管名称",
              trigger: "blur"
            }
          },
          {
            label: "区管代码：",
            type: "input",
            value: "code",
            placeholder: "请输入",
            maxlength: 10,
            rule: {
              required: true,
              message: "请填写区管代码",
              trigger: "blur"
            }
          },
          {
            label: "借平台标志：",
            type: "select",
            value: "borrowFlag",
            placeholder: "请输入",
            optionData: [
              { name: "本平台", value: "0" },
              { name: "借平台", value: "1" },
            ],
            rule: {
              required: true,
              message: "请选择借平台标志",
              trigger: "blur"
            }
          },
          {
            label: "地址：",
            type: "input",
            value: "address",
            placeholder: "请输入",
            maxlength: 300,
            rule: {
              required: false,
              message: "请填写地址",
              trigger: "blur"
            }
          },
          {
            label: "市区标志：",
            type: "select",
            value: "citySign",
            placeholder: "请输入",
            optionData: [
              { name: "区", value: "0" },
              { name: "市", value: "1" },
              { name: "第三方", value: "2" },
            ],
            rule: {
              required: true,
              message: "请选择市区标志",
              trigger: "blur"
            }
          },
          {
            label: "地图坐标：",
            type: "input",
            value: "mapCoordinates",
            placeholder: "请输入",
            maxlength: 300,
            rule: {
              required: false,
              message: "请填写地图坐标",
              trigger: "blur"
            }
          },
          {
            label: "开户行：",
            type: "input",
            value: "depositBank",
            placeholder: "请输入",
            maxlength: 30,
            rule: {
              required: false,
              message: "请填写开户行",
              trigger: "blur"
            }
          },
          {
            label: "帐号：",
            type: "input",
            value: "accountNumber",
            placeholder: "请输入",
            maxlength: 30,
            rule: {
              required: false,
              message: "请填写帐号",
              trigger: "blur"
            }
          },
          {
            label: "行号：",
            type: "input",
            value: "bankNumber",
            placeholder: "请输入",
            maxlength: 20,
            rule: {
              required: false,
              message: "请填写行号",
              trigger: "blur"
            }
          },
          {
            label: "是否废止：",
            type: "select",
            value: "abolishFlag",
            placeholder: "请输入",
            optionData: [
              { name: "否", value: "0" },
              { name: "是", value: "1" },
            ],
            rule: {
              required: true,
              message: "请选择是否废止",
              trigger: "blur"
            }
          },
        ]
      },
    ];
  }
}
